import { Observable } from 'rxjs'
import {
  FlexTransactionActionRequest,
  FlexTransactionActionResponse,
} from '../models/transaction-action.model'

/**
 * Seam between the workbench UI and the Flex Transactions *write* API, mirroring the
 * {@link WorkbenchDataSource} / {@link FieldCatalogService} seams so specs and any mock path can
 * swap it. Provided on the panel component alongside those two.
 *
 * Deliberately verb-agnostic: one {@link submit}, no `match()` / `unmatch()` wrappers. A new verb
 * (Ignore / Hold, PVAL-26310) must not need a new method here — it needs an enum member and an
 * `ACTION_SIDES` entry. Per-verb ergonomics belong in the caller, which is the only place that knows
 * which rows a verb is scoped to.
 */
export abstract class TransactionActionsService {
  /**
   * Submit one action.
   *
   * @param request the body, built by `buildFlexTransactionActionRequest` so unused sides are
   *                absent rather than empty
   * @returns the created command ids. A validation failure is delivered to the caller as an
   *          `HttpErrorResponse` carrying the server's own message — a 400 for a rule the user
   *          broke, a 409 for a concurrent change to the same rows. Those two statuses are also the
   *          ones kept out of the global error drawer (`WORKFLOW_ERROR_STATUSES` in the HTTP
   *          implementation); any other status is recorded there as a defect *in addition to* being
   *          rethrown here.
   */
  abstract submit(
    request: FlexTransactionActionRequest,
  ): Observable<FlexTransactionActionResponse>
}
